import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isAuthenticatedPublisher } from "../services/authAccess";

type PublisherLogoutControlProps = {
  onLogout?: () => void;
};

export function PublisherLogoutControl({
  onLogout,
}: PublisherLogoutControlProps = {}) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!isAuthenticatedPublisher(user)) {
    return null;
  }

  function handleLogout() {
    logout();
    onLogout?.();
    navigate("/log-in", { replace: true });
  }

  return (
    <button
      aria-label="Log out"
      className="oac-publisher-logout"
      onClick={handleLogout}
      title="Log out"
      type="button"
    >
      <svg
        aria-hidden="true"
        className="oac-publisher-logout__icon"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 4v5.25"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.25"
        />
        <path
          d="M7.05 7.05a6.95 6.95 0 1 0 9.9 0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.25"
        />
      </svg>
    </button>
  );
}
